import { set } from 'lodash'
export class FrontEndError {
  public errors: any = {}
  constructor(errorKey, errorMessage) {
    set(this.errors, errorKey, { msg: errorMessage })
  }
}
